/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import RemoveCostCenterForm from './RemoveCostCenterForm/RemoveCostCenterForm';
import RemoveCostCenterSuccess from './RemoveCostCenterSuccess/RemoveCostCenterSuccess';
import RemoveCostCenterError from './RemoveCostCenterError/RemoveCostCenterError';
import Form from '../../../../../forms/_.extend';

import Loading from 'components/Loading/Loading';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveCostCenter extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const project: Object = this.props.project;

    const fields: Array<Object> = [
      {
        name: 'removeCostCenters',
        label: t('general:actions.select_cost_centers'),
        title: 'Select Cost Center(s)',
        fields: [
          {
            name: 'costCenterIds',
            label: '',
            rules: 'required|array',
            value: [],
            placeholder: t('general:placeholders.cost_center_code_name'),
          },
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required|string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { costCenterIds, reason }: Object = data.values().removeCostCenters;

        actionDrawerStore.removeCostCentreFromProject(project.id, {
          ids: costCenterIds,
          remove_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Remove Cost Center(s)',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const project: Object = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.remove_cost_center_plural')} />
          <RemoveCostCenterError {...project} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.archived}`}>
          <ActionDrawerHeader title={t('general:actions.remove_cost_center_plural')} />
          <RemoveCostCenterSuccess {...project} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.remove_cost_center_plural')} />
        <RemoveCostCenterForm {...project} form={this.createForm()} />
      </div>
    );
  }
}
